import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "@/assets/fade-in.css";
import "@/assets/element-variables.scss";
import "@/assets/normalize.scss";
import "@/assets/iconfont.css";
import systemInit from "@/utils/system";
import { CDN } from "@/utils/constants/constants";
import "lib-flexible/flexible";
import "animate.css";
import { savePoint } from "@/utils/common";

Vue.config.productionTip = false;
console.log("process.env:", process.env);
Vue.use(ElementUI);
/** 官网OSS origin **/
Vue.prototype.$cdn = CDN;
Vue.prototype.savePoint = savePoint;
systemInit.basicFunctionInit();
systemInit.basicListenersInit();

const app = new Vue({
  router,
  store,
  // options: {
  //   px2rem: false, // 是否将px转换成rem
  // },
  render: (h) => h(App),
}).$mount("#app");

router.app = app; // 将 app 对象传递给 Vue Router
// router.afterEach((to, from, next) => {
//   setTimeout(() => {
//     // 定义百度统计URL获取函数
//     const getBaiduTongjiUrl = () => {
//       switch (window.location.host) {
//         case "sem.qianlima.com":
//           return "https://hm.baidu.com/hm.js?067c45b4bcb751bbdc527d5e1a2cfd3e";
//         case "qlmzhaobiao.com":
//           return "https://hm.baidu.com/hm.js?80576491d4ac9f9fd9f0a21b8ba91a47";
//         case "www.qianlimazb.com":
//           return "https://hm.baidu.com/hm.js?7e29c4f7884086e7d60e2f46dfeeec70";
//         case "www.hbbidding.cn":
//           return "https://hm.baidu.com/hm.js?1ba2f3c16c3a69f6dd545b69792ff7b0";
//         default:
//           return "";
//       }
//     };
    
//     // 获取统计URL
//     const baiduTongjiUrl = getBaiduTongjiUrl();
//     if (!baiduTongjiUrl) return;
    
//     // 移除旧的统计脚本
//     const oldScript = document.getElementById("baidu_tj");
//     if (oldScript) oldScript.remove();
    
//     // 创建新的统计脚本
//     window._hmt = window._hmt || [];
//     const hmScript = document.createElement("script");
//     hmScript.id = "baidu_tj";
//     hmScript.src = baiduTongjiUrl;
    
//     // 插入到页面
//     const firstScript = document.getElementsByTagName("script")[0];
//     firstScript.parentNode.insertBefore(hmScript, firstScript);
//   }, 0);
// });
